import React from "react";
import SearchSortFilter from "../components/restaurants/filtering/SearchSortFilter";
import RestaurantList from "../components/restaurants/RestaurantList";
import Seo from "../seo";
import { Link } from "gatsby";
import LocateStyles from "../styles/LocateStyles";

const SearchTool = ({ location, data }) => {
  return (
    <>
      <Seo
        title="Search restaurants"
        description="Search the best restaurants for you, your community, and the planet."
        url="https://www.table-sage.com/locate"
        image="https://res.cloudinary.com/table-sage/image/upload/f_auto/v1628259927/general-assets/logo-black-bg-w_yji0cu.png"
        imageWidth="500"
      />

      <LocateStyles>
        <div className="filters">
          <SearchSortFilter
            city="5f69d9b4b28c5e1f8f369c42"
            history={location}
            mobile={false}
          />
        </div>
        <div className="results">
          <RestaurantList
            city="5f69d9b4b28c5e1f8f369c42"
            history={location}
            recommendedRestaurants={data}
          />
        </div>
      </LocateStyles>
      <p className="top-msg learn-more--search-page">
        <Link className="text-link" to="/values">
          Learn more
        </Link>{" "}
        about how we evaluate restaurants.
      </p>
    </>
  );
};

export default SearchTool;
